(function () {
	'use strict';
	$(document).ready(function () {
		const $header = $('header.header');
		const $menuOverlay = $('.menu-overlay');
		const $menuToggle = $(".menu-toggle");
		const headerMenuBreakpoint = 991;

		const isMobileMediaQuery = window.matchMedia(`(max-width: ${headerMenuBreakpoint + 'px'})`);
		isMobileMediaQuery.addEventListener('change', () => {
			closeMenu();
			$menuOverlay.css('display', '');
		});

		// Menu toggle
		$menuToggle.on('click', function () {
			if (isMobileMediaQuery.matches) {
				$menuOverlay.fadeToggle(300);
			}
			$menuOverlay.toggleClass('open');
			$(this).toggleClass("open");
			$header.toggleClass('open');
			closeSubmenus();
		});

		clickedOutside('.menu-overlay', closeMenu, ['.menu-toggle']);

		$('ul.header-main-menu li.menu-item-has-children > a').on('click', function (e) {
			e.preventDefault();
			const $this = $(this);
			const submenuLevel = $this.data('depth');
			if ($this.hasClass('active')) {
				$this.siblings('.submenu').stop().slideUp(300);
				$this.parent().removeClass('open');
				$this.removeClass('active');
			} else {
				closeSubmenus(submenuLevel);
				$this.siblings('.submenu').stop().slideToggle(300);
				$this.parent().toggleClass('open');
				$this.toggleClass('active');
			}
		});

		function closeMenu() {
			$header.removeClass('open');
			$('.menu-toggle').removeClass('open');
			$menuOverlay.removeClass('open');
			closeSubmenus();

			if (isMobileMediaQuery.matches) {
				$menuOverlay.fadeOut();
			}
		}

		function closeSubmenus(dataLevel = 1) {
			$('ul[data-level="' + dataLevel + '"] li.menu-item-has-children > a.active').each(function () {
				$(this).siblings('.submenu').stop().slideToggle(300, function () {
					$(this).css('display', '')
				});
				$(this).removeClass('active');
				$(this).parent().removeClass('open');
			});
		}

	});
}(jQuery));